import {
  ActionIcon,
  AppShell, Avatar, Badge, Burger, Button,
  Divider, Group, Header, Loader, MediaQuery, Menu, Navbar, ThemeIcon, useMantineTheme
} from "@mantine/core";
import React, { useState } from "react";
import { FaBell, FaEllipsisV, FaMoon, FaQuestion, FaSignOutAlt, FaSun } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { GET_NOTIFICATIONS_QUANTITY } from '../services/notifications';
import routes from "../utility/routes";
import RolesSelect from "./roles_select";
import SearchTheme from "./search_theme";

export type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const theme = useMantineTheme();
  
  const [openMore, setOpenMore] = useState(false);
  const [opened, setOpened] = useState(false);
  const [loadingUnread, setLoadingUnread] = useState(false);
  const [unread, setUnread] = useState(0);
  
  const navigate = useNavigate();

  const { user : currentUser, role, hasPermission, logout } = useAuth();
  const { setColorScheme } = useApp();

  const navbarContent: { title: string; key: string ; icon: React.ReactNode; url: string }[] = 
    routes
    .filter((route) => route.menu && hasPermission(route) && (!route.condition || route.condition({user: currentUser, role})))
    .map(({title, key, icon, url}) => ({title, key, icon, url}));

  React.useEffect(() => {
    if(role){
      setLoadingUnread(true)
      GET_NOTIFICATIONS_QUANTITY()
      .then(({unread}) => {
        setLoadingUnread(false)
        setUnread(unread)
      })
      .catch(err => {
        setLoadingUnread(false)
      })
    }
  }, [role])
    
  return (
    <AppShell
      styles={{ main: { background: theme.colors.gray[theme.colorScheme === 'light' ? 0 : 9 ] } }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      fixed
      navbar={
        <Navbar
          hiddenBreakpoint="sm"
          hidden={!opened}
          styles={{ root: { 
            zIndex: 2,
            borderRight: 0, 
            padding: 0,
            background: theme.colors.gray[theme.colorScheme === 'light' ? 0 : 9 ]
          } }}
          width={{ sm: 200, lg: 300 }}
        >
          <Navbar.Section grow mt="md" p="xs" style={{overflowY: 'auto'}}>
            <Button
              variant="subtle"
              color="light"
              size="lg"
              onClick={() => navigate("/perfil")}
              fullWidth
              p="xs"
              styles={{
                inner: { fontWeight: 'lighter', fontSize: 15, marginBottom: 10, justifyContent: 'flex-start' },
              }}
              leftIcon={<ThemeIcon size="lg"><Avatar color="blue" src={currentUser?.image} /></ThemeIcon>}
            >{currentUser?.name}</Button>
            {/* {navbarContent.filter(nc => (selfProfile?.resources || []).some(rs => rs.key === nc.key)).map((item) => ( */}
            {navbarContent.map((item) => (
              <Button
                onClick={() => { setOpened(false); navigate(item.url); }}
                variant="subtle"
                color="light"
                size="lg"
                fullWidth
                p="xs"
                styles={{
                  inner: { fontWeight: 'lighter', fontSize: 15, marginBottom: 10, justifyContent: 'flex-start'},
                }}
                leftIcon={<ThemeIcon size="lg">{item.icon}</ThemeIcon>}
                key={item.key}
              >{item.title}</Button>
            ))}
            <Button
              onClick={() => { window.open("mailto:contato@dmoc.com.br?subject=DMOC - Nova Solicitação", "_blank"); }}
              variant="subtle"
              color="light"
              size="lg"
              fullWidth
              p="xs"
              styles={{
                inner: { fontWeight: 'lighter', fontSize: 15, marginBottom: 10, justifyContent: 'flex-start'},
              }}
              leftIcon={<ThemeIcon size="lg"><FaQuestion /></ThemeIcon>}
            >Fale conosco</Button>
          </Navbar.Section>
          <Divider ml="xs" />
          <Navbar.Section m="xs" style={{textAlign: 'center', paddingBottom: 5}}>
            <Link style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}} to="/privacidade" target="_blank">Privacidade</Link>
            <span style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}}>&nbsp;•&nbsp;</span>
            <Link style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}} to="/termos" target="_blank">Termos</Link>
            <span style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}}>&nbsp;•&nbsp;</span>
            <Link style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}} to="/cookies" target="_blank">Cookies</Link>
            <br/>
            <Link to="https://fridom.com.br" target="_blank" style={{fontSize: 12, textDecoration: 'none', color: theme.colors.gray[5]}}>DMOC © {new Date().getFullYear()}</Link>
          </Navbar.Section>
        </Navbar>
      }
      header={
        <Header height={70} p="md">
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
              <Burger
                opened={opened}
                onClick={() => setOpened((o) => !o)}
                size="sm"
                color={theme.colors.gray[6]}
                mr="xl"
              />
            </MediaQuery>

            <Link to="/" style={{position: 'relative'}}>
              <div style={{backgroundImage: 'url(/icon.png)', backgroundPosition: 'center center', backgroundSize: 'cover', cursor: 'pointer', width: 40, height: 40, borderRadius: 5}} />

              <Badge size="xs" color="gray" style={{position: 'absolute', left: -15, top: -12}}>BETA</Badge>
            </Link>

            {/* <MediaQuery smallerThan="md" styles={{ display: 'none' }}>
              
            </MediaQuery> */}

            <RolesSelect refresh={true} />
            
            <MediaQuery smallerThan="md" styles={{ display: 'none' }}>
              <div style={{flex: 1}}>
              </div>
            </MediaQuery>

            <MediaQuery largerThan="md" styles={{ display: 'none' }}>
              <Group>
                <Menu opened={openMore}>
                  <Menu.Target>
                    <ActionIcon onClick={() => setOpenMore(om => !om)}><FaEllipsisV /></ActionIcon>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <div>
                      <div style={{padding: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
                        {/* <Menu
                          position="bottom"
                        >
                          <Menu.Target> */}
                            {/* <ActionIcon
                              onClick={() => navigate("/notificacoes")}
                              style={{margin: '0 7px'}}
                              variant="outline">
                              <Badge style={{position: 'absolute', top: -10, right: -10}} size="sm" color="red" variant="filled">{unread}</Badge>
                              <FaBell />
                            </ActionIcon> */}
                          {/* </Menu.Target>
                          <Menu.Dropdown>
                            <Paper style={{height: '80vh', overflowY: 'auto'}}>
                              {notifications.map(not => <>
                                <Stack onClick={() => not.theme && openTheme(not.theme)} style={{padding: '10px 30px 10px 10px', cursor: 'pointer'}}>
                                  <Group position="apart" style={{ marginBottom: 5 }}>
                                    <Text weight={500}>{not.title}</Text>
                                    <Badge color={not.theme?.origin === 'camara' ? "green" : "blue"} variant="light">
                                      {not.theme?.origin}
                                    </Badge>
                                  </Group>
                          
                                  <Text size="sm" weight={200} style={{ lineHeight: 1.5 }}>
                                    {not.body}
                                  </Text>

                                  <Text size="xs" align="right" color="blue">
                                    {spentTime(not.datetime)}
                                  </Text>

                                </Stack>
                                <Divider />
                              </>)}
                            </Paper>
                          </Menu.Dropdown>
                        </Menu> */}

                        <ActionIcon
                          style={{margin: '0 7px'}}
                          onClick={() => setColorScheme(theme.colorScheme === 'light' ? 'dark' : 'light')}
                          variant="outline">
                          {theme.colorScheme === 'light' ? <FaSun /> : <FaMoon />}
                        </ActionIcon>
                        <ActionIcon
                          style={{margin: '0 7px'}}
                          onClick={() => logout()}
                          variant="outline">
                          <FaSignOutAlt />
                        </ActionIcon>
                        <SearchTheme type="specific" />
                      </div>
                    </div>
                  </Menu.Dropdown>
                </Menu>

                <ActionIcon
                  onClick={() => navigate("/notificacoes")}
                  style={{margin: '0 7px'}}
                  variant="outline">
                  <Badge style={{position: 'absolute', top: -10, right: -10}} size="sm" color="red" variant="filled">{loadingUnread ? <Loader size="xs" color="yellow" /> : unread}</Badge>
                  <FaBell />
                </ActionIcon>
                <ActionIcon
                  style={{margin: '0 7px'}}
                  onClick={() => navigate("/perfil")}
                  size="md"
                  variant="outline">
                  <Avatar size="md" src={currentUser?.image} style={{ background: '#EFEFEF', borderRadius: '50%' }} />
                </ActionIcon>
              </Group>
            </MediaQuery>
            
            <MediaQuery smallerThan="md" styles={{ display: 'none' }}>
              <div>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
                  {/* <Menu
                    position="left"
                  >
                    <Menu.Target> */}
                      <ActionIcon
                        onClick={() => navigate("/notificacoes")}
                        style={{margin: '0 7px', position: 'relative'}}
                        variant="outline">
                        <Badge style={{position: 'absolute', top: -10, right: -10}} size="sm" color="red" variant="filled">{loadingUnread ? <Loader size="xs" color="yellow" /> : unread}</Badge>
                        <FaBell />
                      </ActionIcon>
                    {/* </Menu.Target>
                    <Menu.Dropdown>
                      <Paper style={{height: '40vh', overflowY: 'auto'}}>
                        {notifications.map(not => <>
                          <Stack onClick={() => not.theme && openTheme(not.theme)} style={{padding: '10px 30px 10px 10px', cursor: 'pointer'}}>
                            <Group position="apart" style={{ marginBottom: 5 }}>
                              <Text weight={500}>{not.title}</Text>
                              <Badge color={not.theme?.origin === 'camara' ? "green" : "blue"} variant="light">
                                {not.theme?.origin}
                              </Badge>
                            </Group>
                    
                            <Text size="sm" weight={200} style={{ lineHeight: 1.5 }}>
                              {not.body}
                            </Text>

                            <Text size="xs" align="right" color="blue">
                              {spentTime(not.datetime)}
                            </Text>

                          </Stack>
                          <Divider />
                        </>)}
                      </Paper>
                    </Menu.Dropdown>
                  </Menu> */}

                  <ActionIcon
                    style={{margin: '0 7px'}}
                    onClick={() => setColorScheme(theme.colorScheme === 'light' ? 'dark' : 'light')}
                    variant="outline">
                    {theme.colorScheme === 'light' ? <FaSun /> : <FaMoon />}
                  </ActionIcon>
                  <ActionIcon
                    style={{margin: '0 7px'}}
                    onClick={() => logout()}
                    variant="outline">
                    <FaSignOutAlt />
                  </ActionIcon>
                  <SearchTheme type="specific" />
                  <ActionIcon
                    style={{margin: '0 20px'}}
                    onClick={() => navigate("/perfil")}
                    size="md"
                    variant="outline">
                    <Avatar size="md" src={currentUser?.image} style={{ background: '#EFEFEF', borderRadius: '50%' }} />
                  </ActionIcon>
                </div>
              </div>
            </MediaQuery>
          </div>
        </Header>
      }
    >
      {children}
    </AppShell>
  );
};

export default Layout;